import { createActionGroup, emptyProps } from '@ngrx/store';

export const applicationStatusesGuardActions = createActionGroup({
  source: 'Application Statuses Exists Guard',
  events: { 'Can Activate': emptyProps() },
});
